import { Avatar, Button, Col, Row, Text } from 'components';
import { format } from 'date-fns';
import { theme } from 'lib';
import { IrreversableModal } from 'screens/Admin/components';
import { Media } from './';

const Story = ({ story, visible, handleRemove, setVisible, closeModal }) => {
  const now = new Date(),
    { owner, media } = story;

  return (
    <Col start between ht="100%" pad="0 24px">
      <Col wid="100%" noFlex>
        <Row between marg="24px 0 0">
          <Text marg="0 16px 4px" b2 med>
            Owner
          </Text>
        </Row>

        {owner && (
          <Row noFlex start marg="0 0 0">
            <Row center between wid="100%" pad="0 0">
              <Row noFlex center>
                <Avatar small user={owner} />

                <Col marg="0 0 0 8px" noFlex>
                  <Text>{owner?.name}</Text>

                  <Text c1 col={theme.GREY_60}>
                    @{owner?.username}
                  </Text>
                </Col>
              </Row>
            </Row>
          </Row>
        )}

        <Col marg="0 0 0" wid="100%">
          <Media story={story} media={media} />
        </Col>

        <Text marg="24px 16px 4px" b2 med>
          Last updated at
        </Text>

        <Text marg="0 16px 0">{format(new Date(story.createdAt), 'MMM do Y, h:mm aa')}</Text>
      </Col>

      <Row pad="54px 0 24px">
        <Button big text="Cancel" onClick={closeModal} marg="0 24px 0 0" bordered />
      </Row>

      <IrreversableModal
        visible={visible === 'remove'}
        heading="You are about to remove this story."
        onConfirm={handleRemove}
        closeModal={() => setVisible(null)}
      />
    </Col>
  );
};

export default Story;
